import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { FileService } from 'src/app/services/file.service';
import { ImageTypes } from 'src/app/services/global-constants';
import { ImageuploadService } from 'src/app/services/imageupload.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { QuestionBank } from 'src/app/misc/data/questionBank';
import { Editor } from 'primeng/editor';
import { cloneDeep, forEach } from 'lodash';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import icons from '../../../../misc/data/icons.json';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService, MenuItem, TreeNode } from 'primeng/api';
import { Location } from '@angular/common';
import { Chips } from 'primeng/chips';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';


@Component({
  selector: 'app-add-question',
  templateUrl: './add-question.component.html',
  styleUrls: ['./add-question.component.scss']
})
export class AddQuestionComponent {

  @ViewChild("externalMailChips") externalMailChipsInput?: ElementRef<Chips>

  sidebarVisible: boolean = false;
  showSelectServiceModal: boolean = false;
  header = this.translate('Add a question');
  assignUserHeader = this.translate('Add participants');
  fromTraining: boolean = false;
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: '/survey',
      click: true,
    },
  ];

  popUpLinks: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: '/announcement',
      click: true,
    },
  ];

  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Polls'), link: '/survey' },
    { name: this.translate('Add a question'), link: '/survey/add-question' },
  ];

  assignUserBreadcrumbs: breadcrumb[] = [
    { name: this.translate('Assessment'), link: '/assessment' },
    { name: this.translate('Add a question'), link: '/assessment/add-question' },
    { name: this.translate('Add participants'), link: '/assessment/add-question' },
  ];

  PopUpbreadcrumbs: breadcrumb[] = [
      { name: this.translate('Announcements'), link: `/announcement` },
      { name: this.translate('Add a question'), link: '/assessment/add-question' },
  ];

  queryParams: any = {};
  allowedConditionals: string[] = ['SELECT_ONE', 'SELECT_MANY', 'DROPDOWN_MENU', 'SELECT_ONE_IMAGE', 'SELECT_MANY_IMAGE', 'SMILE_RATING'];
  difficultyLevels = [{ label: this.translate("Unidentified"), value: "unidentified" }, { label: this.translate("Easy"), value: "easy" }, { label: this.translate("Medium"), value: "medium" }, { label: this.translate("Hard"), value: "hard" }]
  stats: stat[] = [];
  staticFileUrl = GlobalConstants.staticFilesURL;
  surveyAssessmentId: string = '';
  fileInput!: HTMLInputElement;
  messages: any[] = [];
  survey: any = {};
  skelition: boolean = true;
  editingIndex: number = -1;
  questionBank: any = QuestionBank;
  additionIndex: number = -1;


  editorText: string | null = null;
  from: string = 'survey';
  isAssessment: boolean = false;
  isTopic: boolean = false;
  isSurvey: boolean = false;
  iconOptions: any[] = [];
  badgeOptions: any[] = ['Badge1.png', 'Badge2.png', 'Badge3.png', 'Badge4.png'];


  //External Modals 
  showingSelectUser: boolean = false;
  openReorderModal: boolean = false;
  openTopicQAddModal: boolean = false;
  openQAddModal: boolean = false;
  orderableList: any[] = [];
  openAddExternalModal: boolean = false;
  openModal: boolean = false;
  openSettingsModal: boolean = false;
  openGradesModal: boolean = false;
  footerModal: boolean = false;
  openCertificateTextModal: boolean = false;
  openExternalFieldsModal: boolean = false;
  openSelectOUModal: boolean = false;

  //Conditional Questions attributes
  conditionalQuestions: any[] = [];
  linkedQuestions: any[] = [];
  filteredTopicQuestions: any[] = [];


  //Settings Variables
  displayModes: any[] = [{ label: this.translate('Classic'), value: 'Classic' }, { label: this.translate('Focus'), value: 'Focus' }];
  translator: TranslatorPipe = new TranslatorPipe()

  activeTabIndex: number = 0;
  currentQBankId: string = "";
  currentQBank: any[] = [];
  topicQuestions: any[] = [];
  questionsToTopic: any;
  selectedQuestionsToAdd: any[] = [];
  selectedTopicId: string = '';
  selectAllQuestions: boolean = false;
  selectedQuestions: { [key: string]: boolean } = {};
  questionsHideAssessment: string[] = ['EMAIL_ADDRESS', 'CONTACT_INFO', 'IMPACT_MEASUREMENT'];
  topicHideQuestions: string[] = ['PRESENTATION_TEXT', 'SECTION_HEADING', 'SECTION_SUB_HEADING'];
  locationOrigin: string = window.location.origin;
  standardQBID: string = '65f71c25cf3086b3277d7f2d';
  QBTab: string = 'Service';
  oldQBTab: string = 'Service';
  questionBankService: any[] = [];
  filterQuestionBankAll: any[] = [];
  questionBankTopics: any[] = [];
  questionBankAll: any[] = [];
  questionTypes: any = [];

  showSelectServiceModalAutoGen: boolean = false;
  selectedOus: any = []
  selectedOusLabel: string = ""
  topics: any;
  ministries: any;
  dropTopic: any
  filteredQBTopics: any;
  dropMinistry: any
  filteredQBService: any;
  dropGrade: any
  gradeIndex: number = 0;
  dropType: any
  types: any = [
    { id: 1, label: this.translate('Standard Question Bank') },
    { id: 2, label: this.translate('Dedicated Question Bank') }
  ];
  standardQBs: any[] = [];
  showAutoQuestionModal: boolean = false;
  selectedQBs: any[] = [];
  selectedLevels: any[] = [];
  selectedTypes: any[] = [];
  questionLimit: number = 0;
  autoQuestionAdded: number = -1;
  correctError: boolean = false;
  labelError: boolean = false;
  totalError: boolean = false;
  defaultCertText: any =
    {
      "text1": "نتيجة الاختبار الشامل",
      "text2": "ووفقاً لنتائج الاختبار الشامل، ورصد الأخطاء \n في الإجابات، نوصي بمراجعتكم لخدمات الجهات التالية:",
      "text3": "عدد الإجابات الخاطئة حسب الجهات",
      "text4": "كما تميزت إجابتكم في خدمات الجهات التالية:",
      "text5": "مع تمنياتنا لكم \n بالتوفيق والسداد"
    };

  TypeId: string = '';
  source: string = '';
  tags: any;
  isImpactSurvey: boolean = false;
  impactQuestion: any;

  selectedTreeData: any = []
  finalTreeData: any[] = [];
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  selectedTreeTags: MenuItem[] = [];
  staticURL = GlobalConstants.staticFilesURL;
  emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  labelsIdToRemove: string[] = ['64648e3918d4943a0a7b366a', '64648e7118d4943a0a7b366c'];
  labelsToRemove: string[] = ['الجهات المشاركة'];

  email: string = '';

  showReminderModal: boolean = false

  today: Date = new Date();
  startDate: Date = new Date();
  todayDate: Date = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
  tomorrow: Date = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 1);

  constructor(
    private route: ActivatedRoute,
    private fileService: ImageuploadService,
    private dataService: DataService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private clipboard: Clipboard,
    private messageService: MessageService,
    private location: Location,
    private permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {

    this.email = localStorage.getItem('email') || '';

    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.questionBank.forEach((questionBank: any) => {
      questionBank.questions.forEach((question: any) => {
        if (!this.questionsHideAssessment.includes(question.type)) {
          question.name = this.translate(question.name);
          this.questionTypes.push(question);
        }
      });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });

    this.route.queryParams.subscribe(qParams => {
      if (!!qParams['courseId']) {
        this.fromTraining = true;
      }
    })

    this.route.params.subscribe(params => {
      this.surveyAssessmentId = params['questionId'];
      this.from = params['from'];
      if (this.surveyAssessmentId && this.from) {
        this.isAssessment = this.from == 'assessment';
        this.isTopic = this.from == 'topic';
        this.isSurvey = this.from == 'survey';

        const queryParams = this.route.snapshot.queryParams;
        if (queryParams['QBankId']) {
          this.currentQBankId = queryParams['QBankId'];
        }

        if (queryParams['tabIndex']) {
          const savedTabIndex = +queryParams['tabIndex'];
          if (!isNaN(savedTabIndex)) {
            this.activeTabIndex = savedTabIndex;
          }
        }

        if (queryParams['QBTab']) {
          this.oldQBTab = queryParams['QBTab'];
        }

        if (queryParams['TypeId']) {
          this.TypeId = queryParams['TypeId'];
        }

        if (queryParams['source']) {
          this.TypeId = queryParams['source'];
        }

        if (queryParams['fromImpact'] && queryParams['fromImpact'] == 'true') {
          this.isImpactSurvey = true;
          this.questionBank.forEach((questionBank: any) => {
            const impactQuestion = questionBank.questions.filter((question: any) => question.type === 'IMPACT_MEASUREMENT');
            if (impactQuestion.length > 0) {
              this.impactQuestion = impactQuestion[0];
            }
          });
        }

        if (!this.fromTraining) {
          if (this.isAssessment) {
            this.links[0].link = '/assessment/';
            this.links[0].queryParams = {
              'QBankId': this.currentQBankId,
              'tabIndex': this.activeTabIndex,
            }
            this.breadcrumbs[0] = {
              name: this.translate('Assessment'),
              link: '/assessment',
              queryParams: { 'QBankId': this.currentQBankId, 'tabIndex': this.activeTabIndex }
            };
            this.breadcrumbs[1] = {
              name: this.translate('Add a question Assessment'),
              link: '/assessment/add-question/' + this.surveyAssessmentId,
              queryParams: { 'QBankId': this.currentQBankId, 'tabIndex': this.activeTabIndex }
            };
            this.header = this.translate('Add a question Assessment');
            this.assignUserBreadcrumbs[1] = { name: this.translate('Add a question Assessment'), link: '/assessment/add-question/' + this.surveyAssessmentId };
            this.assignUserBreadcrumbs[2] = { name: this.translate('Add participants'), link: '/assessment/add-question/' + this.surveyAssessmentId };
            this.queryParams = { 'QBankId': this.currentQBankId, 'tabIndex': this.activeTabIndex };
          }
          else if (this.isTopic) {
            this.links[0].link = '/assessment/';
            this.links[0].queryParams = {
              'QBankId': this.currentQBankId,
              'tabIndex': this.activeTabIndex,
              'QBTab': this.oldQBTab
            }
            this.breadcrumbs[0] = {
              name: this.translate('Assessment'),
              link: '/assessment',
              queryParams: { 'QBankId': this.currentQBankId, 'tabIndex': this.activeTabIndex, 'QBTab': this.oldQBTab }
            };
            this.breadcrumbs[1] = {
              name: this.translate('Add a question Topic'),
              link: '/topic/add-question/' + this.surveyAssessmentId,
              queryParams: { 'QBankId': this.currentQBankId, 'tabIndex': this.activeTabIndex, 'QBTab': this.oldQBTab }
            };
            this.header = this.translate('Add a question Topic');
            this.assignUserBreadcrumbs[1] = { name: this.translate('Add a question Topic'), link: '/assessment/add-question/' + this.surveyAssessmentId };
            this.assignUserBreadcrumbs[2] = { name: this.translate('Add participants'), link: '/assessment/add-question/' + this.surveyAssessmentId };
            this.queryParams = { 'QBankId': this.currentQBankId, 'tabIndex': this.activeTabIndex, 'QBTab': this.oldQBTab };
          }
          else {
            this.breadcrumbs[0] = {
              name: this.translate('Polls'),
              link: '/survey',
              queryParams: { 'TypeId': this.TypeId }
            };
            this.breadcrumbs[1] = {
              name: this.translate('Add a question Survey'),
              link: '/survey/add-question/' + this.surveyAssessmentId,
              queryParams: { 'TypeId': this.TypeId }
            };
            this.header = this.translate('Add a question Survey');

            this.links[0].link = '/survey/';
            this.links[0].queryParams = { 'TypeId': this.TypeId }
          }
        }
        else {
          if (this.isAssessment) {
            this.header = this.translate('Add a question Assessment');
          }
          else if (this.isTopic) {
            this.header = this.translate('Add a question Topic');
          }
          else {
            this.header = this.translate('Add a question Survey');
          }
          this.links[0].link = '';
          this.breadcrumbs = [];
        }
        Promise.all([this.fetchData(), this.getTreeData()]).then(() => {
          if (this.isAssessment) {
            this.getQBank().then(() => {
              this.getQBankTopics().then(() => {
                this.getStandardQB();
                this.fetchTopics();
              });
            });
          }
        });
      }
      console.log("this.questionBankAll", this.questionBankAll);
      this.skelition = false;
    })
  }

  toggleSelectAll() {
    for (const question of this.filteredTopicQuestions) {
      this.selectedQuestions[question._id] = this.selectAllQuestions;
    }
  }

  filterTopicQuestions(filter: any) {
    if (filter.value == "all") {
      this.filteredTopicQuestions = this.topicQuestions;
    } else {
      this.filteredTopicQuestions = this.topicQuestions.filter(q => q.meta.difficultyLevel == filter.value);
    }
  }

  setServiceLink(service: any) {
    if (service) {
      this.survey.service = service.id;
    }
    this.showSelectServiceModal = false;
  }

  onChangeDropdown() {

    if (this.dropTopic) {
      this.filteredQBTopics = this.questionBankTopics.filter((topics: { topic: any; }) => topics.topic === this.dropTopic._id);
    }

    if (this.dropMinistry) {
      this.filteredQBService = this.questionBankService.filter((item: { data: { ministry: { _id: any; }; }[]; }) => {
        return item.data && item.data[0] && item.data[0].ministry && item.data[0].ministry._id === this.dropMinistry._id;
      });
    }

    if (this.dropType) {
      if (this.dropType.id == 1) {
        if (this.dropMinistry) {

          this.filteredQBService = this.filteredQBService.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
        }
        else {
          this.filteredQBService = this.questionBankService.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
        }
        if (this.dropTopic) {
          this.filteredQBTopics = this.filteredQBTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
        }
        else {
          this.filteredQBTopics = this.questionBankTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
        }
      }
      else {
        if (this.dropTopic) {
          this.filteredQBTopics = this.filteredQBTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
        }
        else {
          this.filteredQBTopics = this.questionBankTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
        }
        if (this.dropMinistry) {
          this.filteredQBService = this.filteredQBService.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
        }
        else {
          this.filteredQBService = this.questionBankService.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
        }
      }
    }
  }

  resetFilters() {
    this.dropMinistry = null;
    this.dropTopic = null;
    this.dropType = null;
    this.filteredQBTopics = this.questionBankTopics;
    this.filteredQBService = this.questionBankService;
  }

  getIconClass(icon: string) {
    if (icon.includes('fa')) {
      return 'fa ' + icon;
    } else {
      return 'pi ' + icon;
    }
  }

  async fetchData() {
    this.skelition = true;
    try {
      let res = await this.dataService.getData(`${this.from}/id/${this.surveyAssessmentId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.survey = res.data;

      const [day, month, year] = this.survey.startDate.split(" ")[0].split("-").map(Number);
      this.startDate = new Date(year, month - 1, day);

      this.tags = (this.isAssessment) ? this.survey.tags[0] : this.survey.type;

      if (this.isAssessment) {
        this.survey.percentageCriteria.forEach((criteria: any) => {
          if (!criteria.certificateText) {
            criteria.certificateText = { top: '', middle: '', bottom: '' };
          }
          if (this.survey.certificateMinistry == undefined) {
            this.survey.certificateMinistry = this.defaultCertText;
          }
        });
      }

      console.log("this.survey.percentageCriteria", this.survey.percentageCriteria)

      this.getConditionalQuestions();
      this.linkedQuestions = this.survey.questions;
      this.skelition = false;
    } catch (e) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e },
      ]
    }
  }

  private async fetchTopics(): Promise<void> {
    this.skelition = true;
    let res = await this.dataService.getData(`question-bank/get-topics/1/1000/Topic`);
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.topics = res.data;
    this.skelition = false;
  }

  async getQBankTopics() {
    try {
      let res = await this.dataService.getData(`topic/questionbank/${this.currentQBankId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.questionBankAll = res.data;

      console.log("this.questionBankAll", this.questionBankAll);
      this.questionBankTopics = res.data.filter((item: { type: string; }) => item.type === 'Topic');
      this.questionBankService = res.data.filter((item: { type: string; }) => item.type === 'Service');
      this.filterQuestionBankAll = this.questionBankAll;
    } catch (error) {
      console.log(error);
    }
  }

  async getQBank() {
    try {
      let res = await this.dataService.getData(`question-bank/${this.currentQBankId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.currentQBank = res.data;

      console.log("this.currentQBank", this.currentQBank);
    } catch (error) {
      console.log(error);
    }
  }

  async getStandardQB() {
    this.skelition = true;
    try {
      let res = await this.dataService.getData(`question-bank/${this.standardQBID}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.standardQBs = res.data;
      let standard = false;
      if (this.currentQBank.length > 0) {
        standard = this.currentQBank[0].standard;
      }
      standard = (standard == undefined || standard == false) ? false : true;
      if (standard && this.standardQBs.length > 0) {
        let StandardQBTopic = this.standardQBs[0].topics.filter((item: { type: string; }) => item.type === 'Topic');
        let StandardQBService = this.standardQBs[0].topics.filter((item: { type: string; }) => item.type === 'Service');
        this.questionBankTopics.push(...StandardQBTopic);
        this.questionBankService.push(...StandardQBService);
        this.questionBankAll.push(...this.standardQBs[0].topics);
      }

      this.ministries = this.questionBankService
        .filter(item => item?.data && item.data.length > 0)
        .map(item => item.data[0]?.ministry)
        .filter((ministry, index, self) =>
          index === self.findIndex(t => (
            t.id === ministry.id
          ))
        );

      this.filteredQBTopics = this.questionBankTopics;
      this.filteredQBService = this.questionBankService;
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  }

  print(event: any) {
    console.log('PRINT EVENT', event);
  }

  disableConditionalOptions(current: any) {
    this.conditionalQuestions = this.conditionalQuestions.map((q: any) => {
      q.disabled = (q.questionCode == current.questionCode);
      return q;
    });
    return this.conditionalQuestions;
  }

  disableLinkedOptions(current: any) {
    this.linkedQuestions = this.linkedQuestions.map((q: any) => {
      q.disabled = (q.questionCode == current.questionCode);
      return q;
    });
    return this.linkedQuestions;
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.orderableList, event.previousIndex, event.currentIndex);
  }

  async addQuestion(question: any, resetIndex: boolean = true, saveProgress: boolean = false, fromTopic: boolean = false) {
    if (this.survey) {
      let cloned = cloneDeep(question);
      if (this.openExternalFieldsModal) {
        cloned.questionCode = 'Q' + (this.survey.externalQuestions.length + 1);
      }
      else {
        cloned.questionCode = 'Q' + (this.survey.questions.length + 1);
      }

      if (this.survey.type && this.isTopic) {
        cloned.meta.QType = this.survey.type;
        if (this.survey.type == 'Topic') {
          cloned.meta.topic = this.survey.topic;
        } else if (this.survey.type == 'Service') {
          cloned.meta.service = this.survey.service;
        }
      }

      cloned.meta.marks = this.survey.defaultScore;

      if (!fromTopic) {
        if (cloned.questionText) {
          cloned.meta.placeholder = cloned.questionText;
          cloned.questionText = "";
        }

        if (cloned.meta.leftAnchor && cloned.meta.rightAnchor) {
          cloned.meta.leftAnchorPlaceholder = cloned.meta.leftAnchor;
          cloned.meta.rightAnchorPlaceholder = cloned.meta.rightAnchor;
          cloned.meta.leftAnchor = "";
          cloned.meta.rightAnchor = "";
        }

        if (cloned.meta.topAnchor && cloned.meta.bottomAnchor) {
          cloned.meta.topAnchorPlaceholder = cloned.meta.topAnchor;
          cloned.meta.bottomAnchorPlaceholder = cloned.meta.bottomAnchor;
          cloned.meta.topAnchor = "";
          cloned.meta.bottomAnchor = "";
        }

        if (cloned.meta.columns) {
          cloned.meta.columnsPlaceholder = cloned.meta.columns;
          cloned.meta.columns = [];
        }

        if (cloned.meta.fields) {
          cloned.meta.fields.forEach((label: any, index: number) => {
            if (cloned.meta.fields[index].label != undefined) {
              cloned.meta.fields[index].placeholder = cloned.meta.fields[index].label;
              if (cloned.type != 'SMILE_RATING') {
                cloned.meta.fields[index].label = "";
              }
            }
            if (cloned.meta.fields[index].field != undefined) {
              cloned.meta.fields[index].field.placeholder = cloned.meta.fields[index].field.label;
              cloned.meta.fields[index].field.label = '';
            }
          });
        }
      }
      cloned.order = this.additionIndex;
      if (this.openExternalFieldsModal) {
        this.survey.externalQuestions.splice(this.additionIndex, 0, cloned);
      }
      else {
        this.survey.questions.splice(this.additionIndex, 0, cloned);
      }
      this.getConditionalQuestions();
      this.linkedQuestions = this.survey.questions;
    }

    // this.survey.questions.forEach((question: any, index: number) => {
    //   question.questionCode = 'Q' + (index + 1);
    // });

    if (resetIndex) {
      this.additionIndex = -1;
    }
    this.sidebarVisible = false;
    if (saveProgress) {
      await this.saveProgress(false, false);
    }
  }

  addNewPercentageCriteria() {
    this.survey.percentageCriteria.push({ title: '', from: 0, to: 0, icon: 'icon', editable: true })
  }

  removePercentageCriteria(index: number) {
    this.survey.percentageCriteria.splice(index, 1)
  }

  addTopicQuestion(questions: any) {
    this.sidebarVisible = false;
    this.topicQuestions = questions;
    this.filteredTopicQuestions = questions;
    this.openTopicQAddModal = true;
  }

  addQuestionTopic(question: any) {
    let cloned = cloneDeep(question);
    if (this.openExternalFieldsModal) {
      cloned.questionCode = 'Q' + (this.survey.externalQuestions.length + 1);
    }
    else {
      cloned.questionCode = 'Q' + (this.survey.questions.length + 1);
    }
    cloned.order = this.additionIndex;
    this.questionsToTopic = cloned;
    this.openQAddModal = true;
    this.sidebarVisible = false;
  }

  SaveQuestionsToAdd(questionId: any) {
    this.selectedQuestions[questionId] = !this.selectedQuestions[questionId];
  }

  async confirmAddTopicQuestions() {
    const selectedQuestionIds = Object.keys(this.selectedQuestions).filter(questionId => this.selectedQuestions[questionId]);

    const filteredQuestions = this.topicQuestions.filter(question => {
      return selectedQuestionIds.includes(question._id);
    });

    filteredQuestions.forEach(question => {
      this.addQuestion(question, false, false, true);
      this.additionIndex += 1;
    });
    this.selectedQuestions = {};
    this.selectAllQuestions = false;
    this.additionIndex = -1;
    this.openTopicQAddModal = false;
    await this.saveProgress(false, false);
  }

  async confirmAddQuestionTopic() {
    this.survey.questions.splice(this.additionIndex, 0, this.questionsToTopic);
    this.questionsToTopic = null;
    this.selectedTopicId = '';
    this.openQAddModal = false;
    this.additionIndex = -1;
    await this.saveProgress(false, false);
  }

  async updateTopicData() {
    let SelectedTopic = this.questionBankTopics.find(topic => topic._id === this.selectedTopicId);
    SelectedTopic.questions = [...SelectedTopic.questions, this.questionsToTopic];
    try {
      let res = await this.dataService.postData(
        `topic`,
        SelectedTopic,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.getQBankTopics();
    } catch (error) {
      console.log(error);
    }
  }

  ChangeQBTab(tab: string, event: any) {
    this.resetFilters();
    this.QBTab = tab;
    this.activeTabIndex = event.index;
    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: { QBTab: this.QBTab },
      queryParamsHandling: 'merge'
    });
  }

  saveOrder() {
    this.survey.questions = this.orderableList;
    this.openReorderModal = false;
  }

  openReorderableModal() {
    this.orderableList = this.survey.questions.map((q: any, index: number) => {
      q.index = index + 1;
      return q;
    });
    this.openReorderModal = true;
  }

  openSidebar(index: number) {
    console.log('INDEX', index);
    this.additionIndex = index + 1;
    this.sidebarVisible = true;
  }


  async addAttendees(event: any) {
    if (event.emit) {
      this.survey.attendees = event.users.map((u: any) => u._id);
      this.survey.notify = true;
      await this.saveProgress(false, false);
    }
    this.showingSelectUser = false;
  }

  setCurrentEditQuestion(i: number) {
    this.editingIndex = i;
    console.log("setCurrentEditQuestion", this.editingIndex);
  }

  pickImage() {
    this.fileInput = document.createElement('input');
    this.fileInput.type = 'file';
    this.fileInput.addEventListener('change', this.onFileSelected.bind(this));
    this.fileInput.style.display = 'none';
    document.body.appendChild(this.fileInput);
    this.fileInput.click();
  }

  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const res = await this.fileService.uploadImage(file, ImageTypes.survey);
      console.log(res);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
      } else {
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        this.survey.headerImage = res.data;
      }
      document.body.removeChild(this.fileInput);
    }
  }

  async onQuestionImageSelect(event: any, field: any) {
    const file: File = event.target.files[0];
    if (file) {
      const res = await this.fileService.uploadImage(file, ImageTypes.survey);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
      } else {
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        field.url = res.data;
      }
    }
  }

  async saveProgress(showMessage: boolean = true, checkValidations = true) {



    this.skelition = true;
    if (checkValidations) {
      if (!this.isLabelProvided(this.survey.questions)) {
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Add Question Text & Option Label of Following Questions') })
        this.labelError = true;
        this.skelition = false;
        return;
      }
      else {
        this.labelError = false;
      }

      if (this.survey.topics != undefined && this.survey.topics.length > 0) {
        if (!this.isTopicSelected(this.survey.questions)) {
          this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Select Topic of Following Questions') })
          this.skelition = false;
          return;
        }
      }

      if (this.survey && !this.isConditionalProvided(this.survey.questions)) {
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Select Conditional Question') })
        this.skelition = false;
        return;
      }

      if (this.isAssessment && !this.isCorrectProvided(this.survey.questions)) {
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Select Correct Answers of Following Questions') })
        this.correctError = true;
        this.skelition = false;
        return;
      }
      else {
        this.correctError = false;
      }

      if (this.isAssessment && this.getSumOfQuestionMarks() != this.survey.totalMarks) {
        this.totalError = true;
        this.skelition = false;
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Sum of Questions Marks are not Equal to Total Marks') })
        return;
      }
      else {
        this.totalError = false;
      }
    }

    if (this.openExternalFieldsModal) {
      if (!this.isLabelProvided(this.survey.externalQuestions)) {
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Add Question Text & Option Label of Following Questions') })
        this.labelError = true;
        this.skelition = false;
        return;
      }
      else {
        this.labelError = false;
      }
    }

    if (this.survey?.topics) {
      if (this.survey?.topics.length > 0) {
        console.log("check with topics too", this.survey.topics);

        this.survey.topics.forEach((topic: any) => {
          this.deleteChildParent(topic);
        });
      }

    }

    // Process survey questions
    this.survey.questions.forEach((question: any) => {
      if (question.meta?.selectedTopic) { // Ensure selectedTopic exists
        // Modify parent if it exists
        if (question.meta.selectedTopic.parent) {
          question.meta.selectedTopic.parentId = question.meta.selectedTopic.parent.key;
          delete question.meta.selectedTopic.parent;
        }

        // Process children for the current question
        (question.meta.selectedTopic.children || []).forEach((innerchild: any) => {
          this.deleteChildParent(innerchild);
        });
      } else {
        console.error("Missing 'selectedTopic' in question:", question);
      }
    });


    console.log(this.survey)

    try {
      let res = await this.dataService.postData(this.from, this.survey, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.survey.notify = false;
      if (showMessage) {
        this.messageService.add({ severity: 'success', summary: this.translate('success') });
        if (this.fromTraining) {
          this.location.back();
        }
      }
      this.skelition = false;
      if (this.openExternalFieldsModal) {
        this.openExternalFieldsModal = false;
        this.openSettingsModal = false;
      }
    } catch (e) {
      this.skelition = false;
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e },
      ];
    }


  }

  deleteChildParent(child: any) {
    // Avoid circular references
    if (child.parent) {
      // Ensure parent is not circular
      if (!child.parent._processed) {
        child.parentId = child.parent.key;
        delete child.parent._processed;  // Clean up any previous flags if needed
        delete child.parent;
      }
    }

    // If no children, return the modified child
    if (!child.children || child.children.length < 1) {
      return child;
    } else {
      // Process children recursively
      child.children.forEach((innerchild: any) => {
        this.deleteChildParent(innerchild);
      });
    }
  }

  // addExternalEmailWithoutEnter() {
  //   const event = new KeyboardEvent('keydown', {
  //     key: 'Enter',
  //     code: 'Enter',
  //     keyCode: 13,
  //     charCode: 13,
  //     which: 13,
  //     bubbles: true,
  //   });

  //   if (!!this.externalMailChipsInput) {
  //     this.externalMailChipsInput.nativeElement.
  //   }
  // }

  async generateQuestions() {
    if (this.questionLimit == 0) {
      this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: '' })
      return;
    }

    console.log("this.selectedOus", this.selectedOus);

    try {
      let data: any = {
        QBs: this.selectedQBs,
        Types: this.selectedTypes,
        Levels: this.selectedLevels,
        limit: this.questionLimit,
        Service: this.selectedOus.map((e: any) => e._id).slice(0, this.questionLimit)
      };
      let res = await this.dataService.postData(`question-bank/generate-questions/${this.currentQBankId}`, data, 'POST', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      console.log("res.data", res.data);

      let questionsToAdd = 0;
      res.data.forEach((item: any) => {
        console.log("item", item.questions)
        if (item.questions) {
          let questionItem = item.questions;
          if (questionItem.question) {
            if (questionItem.topic) {
              questionItem.question.meta.QType = questionItem.topic.type;
              questionItem.question.meta.service = questionItem.topic.service;

              if (questionItem.topic.ous) {
                const sortedOus = questionItem.topic.ous.sort((a: any, b: any) => b.depth - a.depth);
                const firstOu = sortedOus[0];
                questionItem.question.meta.servicelabel = firstOu.label || '';
                questionItem.question.meta.serviceIcon = firstOu.icon || '';
              }
            }
            this.addQuestion(questionItem.question, false, false, true);
            this.additionIndex += 1;
            questionsToAdd += 1;
          }
        }
      });

      this.additionIndex = -1;
      this.showAutoQuestionModal = false;
      this.selectedQBs = [];
      this.selectedTypes = [];
      this.selectedLevels = [];
      this.selectedOus = [];
      this.questionLimit = 0;
      this.autoQuestionAdded = questionsToAdd;
    } catch (error) {
      console.log(error);
    }


  }

  async gotoUrl(url: string, id: string, newTab: boolean) {
    if (url.includes('certificate')) {
      this.openSettingsModal = false;
    }
    await this.saveProgress(false, false);

    let queryParams: any = {};
    let params = [];
    if (newTab) {
      if (this.isAssessment || this.isTopic) {
        if (url.includes('attempt') || url.includes('certificate')) {
          queryParams['userTesting'] = 1;
        }
        if (url.includes('results') || url.includes('certificate')) {
          queryParams['QBankId'] = this.currentQBankId;
          queryParams['tabIndex'] = this.activeTabIndex;
        }
      } else {
        if (url.includes('survey')) {
          if (url.includes('results')) {
            queryParams['TypeId'] = this.TypeId;
          }
          if (url.includes('attempt')) {
            queryParams['userTesting'] = 1;
          }
        }
      }
      const queryString = new URLSearchParams(queryParams).toString();
      window.open(`${url}?${queryString}`, '_blank');
    } else {
      window.open(`/survey/attendance/${id}`, '_self');
    }
  }


  copyURL(url: string) {
    this.clipboard.copy(location.origin + url);
    this.messages = [
      { severity: 'success', summary: this.translate('success') },
    ];
  }

  getConditionalQuestions() {
    this.conditionalQuestions = this.survey.questions.filter((q: any) => this.allowedConditionals.includes(q.type));
  }

  getConditionalOptions(question: any) {
    return question?.meta?.condition?.question?.meta?.fields;
  }

  //Input field methods
  addRowInTextInput(question: any, index: number) {
    question.meta.fields.push({ label: 'صف ' + (question.meta.fields.length + 1), valueLabel: question.meta.fields[0].valueLabel })
  }

  removeRowInTextInput(question: any, index: number, questionIndex: number) {

    if (question.meta.fields.length == 1) {
      this.removeQuestion(questionIndex);
    } else {
      question.meta.fields.splice(index, 1);

    }
    this.survey = this.survey;
  }

  selectImage(ref: HTMLInputElement) {
    ref.disabled = false;
    ref.click();
    ref.disabled = true;
  }

  addImageToSelected(question: any, label: string) {
    if (question.meta.correct.includes(label)) {
      let index = question.meta.correct.indexOf(label);
      question.meta.correct.splice(index, 1);
    } else {
      question.meta.correct.push(label);
    }
  }

  removeQuestion(questionIndex: number, openExternalFieldsModal = false) {
    if (openExternalFieldsModal) {
      this.survey.externalQuestions.splice(questionIndex, 1);
    }
    else {
      let removedQuestionCode = this.survey.questions[questionIndex]?.questionCode;
      console.log("removedQuestionCode", removedQuestionCode);
      this.survey.questions.splice(questionIndex, 1);
      this.survey.questions.forEach((question: any) => {
        if (
          question.meta &&
          question.meta.condition &&
          question.meta.condition.question &&
          question.meta.condition.question.questionCode === removedQuestionCode
        ) {
          question.meta.conditional = false;
          question.meta.condition.question = null;
          question.meta.condition.option = null;
        }

        if (
          question.meta &&
          question.meta.linkedQ &&
          question.meta.condition.question.questionCode === removedQuestionCode
        ) {
          question.meta.linkedQ = null;
          question.meta.linked = false;
        }
      });
    }
    this.setCurrentEditQuestion(-1);
    this.getConditionalQuestions();
    this.linkedQuestions = this.survey.questions;
  }

  changePageBreak(question: any, index: number) {
    question.pageBreak = !question.pageBreak;
    this.setCurrentEditQuestion(index)
  }

  changeSeparator(question: any, index: number) {
    question.separator = !question.separator;
    this.setCurrentEditQuestion(index)
  }

  openTextModal(footerModal: boolean) {
    this.footerModal = footerModal;
    if (footerModal) {
      this.editorText = this.survey.footerText;
    } else {
      this.editorText = this.survey.thankyouPageText;
    }
    this.openModal = true;
  }

  closeModal() {
    this.editorText = null;
    this.footerModal = false;
    this.openModal = false;
  }

  setText(text: any) {
    console.log(text, this.footerModal);
    if (this.footerModal) {
      this.survey.footerText = text.htmlValue;
    } else {
      this.survey.thankyouPageText = text.htmlValue;
    }
  }

  getRankDDValues(question: any): string[] {
    let values: string[] = [];

    for (let i = 1; i < question.meta.fields.length + 1; i++) {
      values.push(i.toString());
    }

    return values;
  }

  addFieldWithOrder(question: any) {
    question.meta.fields.push({ label: '', placeholder: "خيار " + (question.meta.fields.length + 1), order: (question.meta.fields.length + 1) })
  }

  updateCalendarDate(question: any) {
    console.log('UPDATED DATE');
    question.meta.value = new Date();
  }

  updateColumn(question: any, event: any, index: number) {
    question.meta.columnsPlaceholder.splice(index, 1, event.target.value);
  }

  addColumn(question: any) {
    question.meta.columnsPlaceholder.push('Column ' + (question.meta.columnsPlaceholder.length + 1))
  }

  addRow(question: any, valueType: any) {
    question.meta.fields.push({
      field: { label: '', placeholder: " خيار" + (question.meta.fields.length + 1), value: valueType },
    });
  }

  launchUrl(url: string) {
    window.open(this.locationOrigin + '/data/' + url, '_blank');
  }

  isCorrectProvided(questions: any[]): boolean {
    return questions.every(question => {
      const fieldsValueTypes = ["STAR_RATING", "RANK_ORDER", "DRAG_DROP"];
      const fieldsFieldValueTypes = ["MULTI_POINT_SCALE"];
      const metaValueTypes = ["SELECT_ONE", "DROPDOWN_MENU", "SELECT_ONE_IMAGE", "SMILE_RATING", "CALENDAR"];
      const metaValueArrayTypes = ["SELECT_MANY", "SELECT_MANY_IMAGE"];
      const fieldsValueArrayTypes = ["MULTI_SELECT_SCALE"];
      const dateTypes = ["DATE_TIME"];

      if (!question || !question.type) {
        return true;
      }

      if (fieldsValueTypes.includes(question.type)) {
        return (
          question.meta &&
          question.meta.fields &&
          Array.isArray(question.meta.fields) &&
          question.meta.fields.every((field: any) =>
            field.correct !== null && field.correct.toString().trim() !== ''
          )
        );
      }

      if (fieldsFieldValueTypes.includes(question.type)) {
        return (
          question.meta &&
          question.meta.fields &&
          Array.isArray(question.meta.fields) &&
          question.meta.fields.every((field: any) =>
            field && field.field && field.field.correct !== undefined && field.field.correct.toString().trim() !== ''
          )
        );
      }

      if (metaValueTypes.includes(question.type)) {
        return (
          question.meta &&
          question.meta.correct !== null &&
          question.meta.correct !== undefined &&
          (question.meta.correct.toString().trim() !== '')
        );
      }

      if (metaValueArrayTypes.includes(question.type)) {
        return (
          question.meta &&
          Array.isArray(question.meta.correct) &&
          question.meta.correct.length > 0
        );
      }

      if (fieldsValueArrayTypes.includes(question.type)) {
        return (
          question.meta &&
          question.meta.fields &&
          Array.isArray(question.meta.fields) &&
          question.meta.fields.some((field: any) =>
            Array.isArray(field.correct) && field.correct.length > 0
          )
        );
      }

      if (dateTypes.includes(question.type)) {
        return (
          question.meta &&
          typeof question.meta.correct === 'object' &&
          question.meta.correct !== null &&
          Object.values(question.meta.correct).every(val => (typeof val === 'string' || typeof val === 'number') && val.toString().trim() !== '')
        );
      }

      return true;
    });
  }

  isConditionalProvided(questions: any[]): boolean {
    return questions.every((question: any) => {
      let condProvided: boolean = true;
      if (!question || !question.type || !question.meta) {
        return true;
      }
      const hasCondition = question.meta.conditional !== undefined ? question.meta.conditional : false;
      const questionCondition = question.meta.condition?.question;
      const optionCondition = question.meta.condition?.option;

      if (hasCondition && (questionCondition === null || questionCondition === undefined || optionCondition === null || optionCondition === undefined)) {
        question.meta.labelError = true;
        condProvided = false;
      } else {
        question.meta.labelError = false;
        condProvided = true;
      }

      return condProvided;
    });
  }


  isLabelProvided(questions: any[]): boolean {
    return questions.every((question: any) => {
      let labelProvided: boolean = true;
      if (!question || !question.type) {
        return true;
      }

      if (question.questionText != undefined && question.questionText.trim() === '') {
        labelProvided = false;
        question.meta.labelError = true;
      }
      else {
        question.meta.labelError = false;
      }

      if (question.meta && question.meta.fields && Array.isArray(question.meta.fields)) {
        const fieldsAreValid: boolean = question.meta.fields.every((field: any) => {
          if (field.label !== undefined) {
            return field.label && field.label.trim() !== '';
          }
          if (field.field && field.field.label !== undefined) {
            return field.field.label && field.field.label.trim() !== '';
          }
        });

        if (!fieldsAreValid) {
          labelProvided = false;
          question.meta.labelError = true;
        }
        else {
          question.meta.labelError = false;
        }
      }

      if (false) {
        if (question.meta && question.meta.leftAnchor != undefined && question.meta.rightAnchor != undefined) {
          if (question.meta.leftAnchor.trim() == '' && question.meta.rightAnchor.trim() == '') {
            labelProvided = false;
            question.meta.labelError = true;
          }
          else {
            question.meta.labelError = false;
          }
        }
      }

      if (question.meta && question.meta.topAnchor != undefined && question.meta.bottomAnchor != undefined) {
        if (question.meta.topAnchor.trim() == '' && question.meta.bottomAnchor.trim() == '') {
          labelProvided = false;
          question.meta.labelError = true;
        }
        else {
          question.meta.labelError = false;
        }
      }

      if (question.meta && question.meta.columns != undefined && question.meta.columnsPlaceholder != undefined) {
        if (question.meta.columns.length != question.meta.columnsPlaceholder.length) {
          labelProvided = false;
          question.meta.labelError = true;
        }
        else {
          question.meta.labelError = false;
        }
      }

      return labelProvided;
    });
  }

  isTopicSelected(questions: any[]): boolean {
    return questions.every((question: any) => {
      let labelProvided: boolean = true;
      if (!question || !question.type) {
        return true;
      }
      if (question.meta) {
        if (question.meta.selectedTopic === undefined || question.meta.selectedTopic === null) {
          labelProvided = false;
          question.meta.labelError = true;
        }
        else {
          question.meta.labelError = false;
        }
      }
      return labelProvided;
    });
  }

  getSumOfQuestionMarks(): number {
    if (this.survey.questions) {
      return this.survey.questions.reduce((sum: number, question: any) => {
        const marks = question.meta.marks || 0;
        return sum + marks;
      }, 0);
    } else {
      return 0;
    }
  }

  onChangeGrade(event: any): void {
    const selectedIndex = this.survey.percentageCriteria.findIndex((option: { title: any; }) => option.title === this.dropGrade.title);
    if (selectedIndex !== -1) {
      this.gradeIndex = selectedIndex;
    }
  }

  getKeys(obj: any): Array<string> {
    return Object.keys(obj);
  }

  canConditional(current: any): boolean {
    return this.survey.questions.some((question: any) =>
      question?.meta?.condition?.question?.questionCode == current.questionCode
    );
  }

  canLinked(current: any): boolean {
    return this.survey.questions.some((question: any) =>
      question?.meta?.linkedQ && question.meta.linkedQ?.questionCode == current.questionCode
    );
  }

  async getTreeData() {
    this.selectedTreeData_orginal = await this.permissionService.extractOUChildren('TRAINING_PROGRAM', 'c')
    this.filterTreeByTag(['Ministries/Entities', 'Organisational Units', 'Branches', 'Organisational Structure']);
  }


  filterTreeByTag(tag: string[]) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });
      this.selectedTreeData = cloneDeep(cloneitems);
    }
  }

  filterNodes(node: any, tag: string[]): any | null {
    // Recursively filter children nodes

    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (tag.includes(node.tag) || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }

  ouChanged(event: any) {
    this.selectedOus = this.selectedOus.filter((node: any) => {
      return !this.labelsIdToRemove.includes(node._id);
    });
    this.selectedOus = this.selectedOus.filter((node: any) => {
      return !this.labelsToRemove.includes(node.label);
    });
    this.selectedOusLabel = this.selectedOus.map((e: any) => e.label).join(', ');

    console.log("this.filterQuestionBankAll", this.filterQuestionBankAll)

    if (this.selectedOus.length > 0) {
      this.filterQuestionBankAll = this.questionBankService.filter((item: any) => {
        return (
          item.data &&
          item.data[0] &&
          item.data[0].breadcrumbs &&
          item.data[0].breadcrumbs.length > 0 &&
          item.data[0].breadcrumbs.some((breadcrumb: any) =>
            this.selectedOus.some((selected: any) => selected._id === breadcrumb._id)
          )
        );
      });
    }
    else {
      this.filterQuestionBankAll = this.questionBankAll;
    }

    console.log("this.filterQuestionBankAll", this.filterQuestionBankAll)

  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  handlePaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') || '';
    const emails = pastedText.split(/[\n,;\s]+/);
    emails.forEach(email => {
      const trimmedEmail = email.trim();
      if (this.emailPattern.test(trimmedEmail)) {
        this.survey.externals.push(trimmedEmail);
      }
    });
    event.preventDefault();
  }


  //code for tree node topic

  treeDataDomains: TreeNode[] = []

  selectedNode: TreeNode | null = null;
  newNodeData: string = '';
  lastSelectedKey: string | null = null;

  toggleSelection(event: any) {
    if (this.lastSelectedKey === event.node.key) {
      this.selectedNode = null; // Deselect node if clicked again
      this.lastSelectedKey = null;
    } else {
      this.lastSelectedKey = event.node.key; // Store new selection
    }
  }

  addNode() {


    if (!this.newNodeData.trim()) return; // Prevent empty values

    if (this.selectedNode) {
      // Add child to the selected node
      if (!this.selectedNode.children) {
        this.selectedNode.children = [];
      }
      const newKey = `${this.selectedNode.key}-${this.selectedNode.children.length}`;
      this.selectedNode.children.push({ key: newKey, label: this.newNodeData, data: this.newNodeData, children: [] });
    } else {
      // Add new root-level node
      const newKey = `${this.treeDataDomains.length}`;
      this.treeDataDomains.push({ key: newKey, label: this.newNodeData, data: this.newNodeData, children: [] });
    }

    this.survey.topics = this.treeDataDomains;

    this.newNodeData = ''; // Clear input field
  }
}
